import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from '../core/services/auth-guard.service';
import { VehiculoEditMovilComponent } from './vehiculo-edit-movil/vehiculo-edit-movil.component';

const routes: Routes = [

  {
    path: 'area-privada',
    canActivate: [AuthGuardService],
    loadChildren: () => import('./area-privada/area-privada.module').then(m => m.AreaPrivadaModule)
  },
  {
    path: 'registro-movil',
    loadChildren: () => import('./registro-movil/registro-movil.module').then(m => m.RegistroMovilModule)
  },
  {
        path: 'edit-vehiculo-movil/:id/:token',
        component: VehiculoEditMovilComponent
  },
  {
    path: '',
    loadChildren: () => import('./landing-page/landing-page.module').then(m => m.LandingPageModule)
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PagesRoutingModule {}
